import ExternalLayer from '../external-layer/external-layer.model';

export default class OrganizationUnit {
    public id = '';
    public name = '';
    public niceName = '';
    public createdAt: Date = new Date();
    public externalLayers: ExternalLayer[] = [];

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }
    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.niceName) {
            this.niceName = model.niceName;
        }
        if (model.externalLayers) {
            this.externalLayers = [];
            for (let i = 0; i < model.externalLayers.length; i++) {
                this.externalLayers.push(new ExternalLayer(model.externalLayers[i]));
            }
        }
        if (model.createdAt) {
            this.createdAt = new Date(model.createdAt);
        }
    }
}
